import { useCallback } from 'react'
import { useApolloClient } from '@apollo/client/react'
import { getExhibitorByIdAndLocale, updateExhibitor } from '../../../../api'

const useExhibitorMutation = () => {
  const client = useApolloClient()

  const getExhibitor = useCallback(
    async (id, locale) => {
      return getExhibitorByIdAndLocale(client, { id, locale })
    },
    [client]
  )

  const mutateExhibitor = useCallback(
    async (exhibitor) => {
      return updateExhibitor(client, exhibitor)
    },
    [client]
  )
  return { mutateExhibitor, getExhibitor }
}

export default useExhibitorMutation
